import { Outlet } from "react-router";

import { RouteAnalytics } from "@/components/analytics/RouteAnalytics";
import { DisclosureFooter } from "@/components/layout/DisclosureFooter";
import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";
import { PageContainer } from "@/components/layout/PageContainer";
import { TenantThemeProvider } from "@/components/tenant/TenantThemeProvider";

// Vite equivalent of `app/app/layout.tsx`. Same visual structure (Header,
// PageContainer, Footer) but mounted via react-router <Outlet/> instead of
// Next.js's nested children. The `<html>`/`<body>` chrome lives in
// `index.html` for Vite. TenantThemeProvider wraps the chrome the same way
// layout.tsx wired it in the Next tree (SFWL-002 white-label theming).
export function AppShell() {
  return (
    <TenantThemeProvider>
      <div className="flex min-h-screen flex-col bg-slate-50 text-slate-900 antialiased">
        <RouteAnalytics />
        <Header />
        <PageContainer>
          <Outlet />
        </PageContainer>
        <Footer />
        <DisclosureFooter />
      </div>
    </TenantThemeProvider>
  );
}
